module.exports = __webpack_public_path__ + "static/media/chg3.0b74c7e6.png";